export default function FinalCTA() {
  return (
    <section className="relative py-32 bg-gray-900 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-8 text-center">
        {/* Main Message */}
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: "'Pretendard', sans-serif", letterSpacing: '-0.02em' }}>
          급할수록 더 좋은 사람과<br />연결되는 게 중요합니다
        </h2>

        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto" style={{ fontFamily: "'Pretendard', sans-serif" }}>
          지금 바로 온니잡으로 시작하세요
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#pricing"
            className="px-10 py-4 bg-white text-gray-900 text-lg font-semibold rounded-full hover:bg-gray-100 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer flex items-center gap-2"
            style={{ fontFamily: "'Pretendard', sans-serif" }}
          >
            지금 바로 써보기
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://pf.kakao.com/_xnxnxnxn"
            target="_blank"
            rel="noopener noreferrer"
            className="px-10 py-4 bg-transparent border-2 border-white text-white text-lg font-semibold rounded-full hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
            style={{ fontFamily: "'Pretendard', sans-serif" }}
          >
            <i className="ri-kakao-talk-fill"></i>
            사장님 채용 시작하기
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-gray-400">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-xl"></i>
            <span className="text-sm" style={{ fontFamily: "'Pretendard', sans-serif" }}>안전한 거래</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-customer-service-2-line text-xl"></i>
            <span className="text-sm" style={{ fontFamily: "'Pretendard', sans-serif" }}>24/7 지원</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-star-fill text-xl text-yellow-400"></i>
            <span className="text-sm" style={{ fontFamily: "'Pretendard', sans-serif" }}>98% 만족도</span>
          </div>
        </div>
      </div>
    </section>
  );
}
